module.exports = __webpack_public_path__ + "static/img/solution_img_4.b0990c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-h/solution_img_4.png
// module id = zlaW
// module chunks = 22